import { Grid, IconButton } from "src/lib/components/basics";
import { ISummaryProps } from "./types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const Summary = ({ open, onToggle, toggleDisabled, children }: ISummaryProps) => {
    return (
        <Grid container justifyContent="space-between">
            <Grid sx={{ width: "98%" }}>{children}</Grid>
            <IconButton
                variant="clean"
                color="neutral"
                disabled={toggleDisabled}
                onClick={toggleDisabled ? undefined : onToggle}
            >
                {open ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
        </Grid>
    );
};

export { Summary }